<template>
    <el-row type="flex" class="tag-list">
        <el-button type="text" class="button" v-show="isTagShow(switchFlag[0])" @click.stop="onClickTag('broadcast')">
            <img src="@/assets/images/homepage/bulletin.svg">
            <span>公告</span>
        </el-button>
        <el-button type="text" class="button" v-show="isTagShow(switchFlag[1])&& this.$public.isCordova()" @click.stop="onClickTag('order')">
            <img src="@/assets/images/homepage/order.svg">
            <span>點餐</span>
        </el-button>
        <el-button type="text" class="button" v-show="isTagShow(switchFlag[2])" @click.stop="onClickTag('booking')">
            <img src="@/assets/images/homepage/book.svg">
            <span>訂位</span>
        </el-button>
        <el-button type="text" class="button" v-show="isTagShow(switchFlag[3])" @click.stop="onClickTag('waiting')">
            <img src="@/assets/images/homepage/wait.svg">
            <span>候位</span>
        </el-button>
        <el-button type="text" class="button" v-show="isTagShow(switchFlag[4])" @click.stop="onClickTag('comment')">
            <img src="@/assets/images/homepage/comment.svg">
            <span>評論</span>
        </el-button>
        <el-button type="text" class="button" v-if="false">
            <img src="@/assets/images/homepage/reservation.svg">
            <span>預訂</span>
        </el-button>
    </el-row>
</template>

<script>
    export default {
        name: "TagList",
        props:{
            switchFlag: { default: function () {
                return [ false, false, false, false, false];
            } },
        },
        data() {
            return {}
        },
        created() {

        },
        mounted() {

        },
        methods: {

            /** */
            onClickTag: function (tag) {
                this.$emit('clickTag', tag);
                // this.$router.push({name: 'CommentPage', params: {id: 1}})
            },

            /** 是否顯示 tag */
            isTagShow: function (tag) {
                return (this.$public.notNull(tag) && tag);
            },
        }
    }
</script>

<style lang="less" scoped>
    .tag-list {
        overflow: auto;
        width: 100%;
        .button {
            padding: 0 8px;
            height: 26px;
            line-height: 22px;
            background: var(--color-yellow);
            border-radius: 10px;
            margin-right: 10px;
            margin-left: 0;
            min-width: 70px;
            img {
                width: 16px;
                margin-right: 6px;
            }
            span {
                color: #595757;
                font-size: 12px;
            }
        }
    }
</style>